import { useEffect, useState } from "react";
import api from "@/lib/api";

// Staging mode is decided by the backend only: GET /staging/status answers
// 200 when STAGING_MODE=true and DB_NAME=erp_staging, and 404 otherwise
// (always, on the live site). Anything other than a 200 with staging:true —
// a 404, a network error, a missing endpoint — means "not staging", so the
// banner and reset button stay hidden by default.
let statusPromise = null;

export function fetchStagingMode() {
  if (!statusPromise) {
    statusPromise = api
      .get("/staging/status")
      .then((res) => res?.data?.staging === true)
      .catch(() => false);
  }
  return statusPromise;
}

export function useStagingMode() {
  const [staging, setStaging] = useState(false);
  useEffect(() => {
    let alive = true;
    fetchStagingMode().then((on) => { if (alive) setStaging(on); });
    return () => { alive = false; };
  }, []);
  return staging;
}
